import { Database, HeartHandshake, History, BarChart3, Sparkles, Users, Inbox } from "lucide-react";
import { NavLink } from "@/components/NavLink";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  useSidebar,
} from "@/components/ui/sidebar";
import { Badge } from "@/components/ui/badge";

const menuItems = [
  { title: "All Profiles", url: "/matchmaker/profiles", icon: Database },
  { title: "Join Requests", url: "/matchmaker/join-requests", icon: Inbox },
  { title: "Smart Matcher", url: "/matchmaker/smart-matcher", icon: Sparkles },
  { title: "Mutual Matches", url: "/matchmaker/mutual-matches", icon: Users },
  { title: "Match History", url: "/matchmaker/history", icon: History },
  { title: "Analytics", url: "/matchmaker/analytics", icon: BarChart3 },
];

export function MatchmakerSidebar() {
  const { open } = useSidebar();

  return (
    <Sidebar className={open ? "w-60" : "w-14"} collapsible="icon">
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel className="flex items-center gap-2">
            {open && (
              <>
                Matchmaker
                <Badge variant="secondary" className="text-xs">Matchmaker</Badge>
              </>
            )}
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <NavLink 
                      to={item.url} 
                      end={item.url === "/matchmaker/profiles"}
                      className="hover:bg-muted/50" 
                      activeClassName="bg-muted text-primary font-medium"
                    >
                      <item.icon className="h-4 w-4" />
                      {open && (
                      <span>{item.title}</span>
                      )}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
